import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Pagination from 'react-js-pagination';

import productActions from '../store/actions/productActions';
import AdvertList from '../components/AdvertList/AdvertList';

import urlHelper from '../helpers/url.helper';
import IconLongArrow from '../components/UI/Icons/IconLongArrow';
import Search from '../components/Search/Search';
import MetaTags from '../components/MetaTags/MetaTags';
import helpers from '../helpers/helpers';
import Container from '../components/UI/Container/Container';

const SearchResults = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const {
    foundProducts,
    foundPagination,
    searchIsLoading,
    isLoading,
  } = useSelector((state) => state.products);
  const { isPageLoading } = useSelector((state) => state);
  const [searchValue, setSearch] = useState(['', '']);

  const { getTranslationText } = helpers;

  const getParams = useCallback((search, page) => {
    let searchFields = '';
    if (search[0] === 'query') {
      searchFields = 'title;link;tag;city;region;country;username';
    }
    if (search[0] === 'u') {
      searchFields = 'username';
    }
    if (search[0] === 'tag') {
      searchFields = 'tag';
    }
    return {
      search: decodeURIComponent(search[1]),
      searchFields,
      page,
    };
  }, []);

  useEffect(() => {
    const url = router.asPath.split('/');
    const query = url[url.length - 1].split('?')[1].split('&');
    const search = query[0].split('=');
    let page = 1;
    if (query[1]) {
      /* eslint-disable-next-line */
      page = query[1].split('=')[1];
    }
    setSearch(search);
    dispatch(productActions.getSearchAllProducts(getParams(search, page)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.asPath]);

  const handlePageChange = (page) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    dispatch(productActions.getSearchAllProducts(getParams(searchValue, page)));
    router.replace(router.route, urlHelper.buildUrl(router, {
      [searchValue[0]]: searchValue[1],
      page,
    }));
  };

  const metDescriptionHandler = (them) => {
    switch (them[0]) {
      case 'query':
        return `Поиск по запросу: ${decodeURIComponent(them[1].split('#').reverse()[0])} на nft-market.bit.team`;
      case 'u':
        return `Товары пользователя: ${decodeURIComponent(them[1].split('#').reverse()[0])} nft-market.bit.team`;
      case 'tag':
        return `Товары по тегу: ${decodeURIComponent(them[1].split('#').reverse()[0])} nft-market.bit.team`;
      default:
        return 'Страница поиска на сайте nft-market.bit.team';
    }
  };

  const description = metDescriptionHandler(searchValue);

  return (
    <>
      <MetaTags metaTitle={helpers.getTranslationText('seo.search_title')} metaDescription={description} />
      <div className="search-results">
        <Container>
          <div className="search-results__title">
            {searchValue[0] === 'query' && getTranslationText('search.search_by_query')}
            {searchValue[0] === 'u' && getTranslationText('search.users_products')}
            {searchValue[0] === 'tag' && getTranslationText('search.products_by_tag')}
            <span>{decodeURIComponent(searchValue[1].split('#').reverse()[0])}</span>
          </div>
          <AdvertList
            products={foundProducts}
            isLoading={searchIsLoading || isLoading || isPageLoading}
          />
        </Container>
        {
        foundPagination.total_pages > 1 && (
          <Pagination
            activePage={foundPagination.current_page}
            itemsCountPerPage={foundPagination.per_page}
            totalItemsCount={foundPagination.total}
            pageRangeDisplayed={8}
            onChange={handlePageChange}
            hideFirstLastPages
            nextPageText={<IconLongArrow color="#4579f5" />}
            prevPageText={<IconLongArrow color="#4579f5" />}
            itemClassNext="next"
            itemClassPrev="prev"
          />
        )
      }
      </div>
    </>
  );
};

export default SearchResults;
